import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import StatusDropdown from './StatusDropdown';
import { useSelectionContext } from '../../contexts/SelectionContext';

/**
 * SelectionAwareDropdown - A dropdown that knows if it's acting on one or many items
 * 
 * When multiple items are selected, ANY dropdown can control ALL selected items.
 * This preserves the current UX while making the code more modular.
 */
const SelectionAwareDropdown = ({ 
  itemId,
  currentStatus,
  onSingleStatusChange,
  onBulkStatusChange,
  disabled = false,
  loading = false,
  size = 'compact'
}) => {
  const { selectedIds, isMultiSelect, selectedCount } = useSelectionContext();
  
  const handleStatusChange = useCallback((newStatus) => {
    if (isMultiSelect) {
      // When multiple items selected, act on ALL selected items
      const selectedIdArray = Array.from(selectedIds);
      onBulkStatusChange(selectedIdArray, newStatus);
    } else {
      // Single selection - act on just this item
      onSingleStatusChange(itemId, newStatus);
    }
  }, [isMultiSelect, selectedIds, itemId, onSingleStatusChange, onBulkStatusChange]);
  
  // Always use bulk mode to show the full "Move to" dropdown
  const mode = 'bulk';
  
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <StatusDropdown
        key={`dropdown-${itemId}-${selectedCount}`}
        mode={mode}
        size={size}
        value={currentStatus}
        onStatusChange={handleStatusChange}
        disabled={disabled}
        loading={loading}
        selectedCount={selectedCount}
      />
    </Box>
  );
};

export default SelectionAwareDropdown;